// extracted by mini-css-extract-plugin
module.exports = {"Input":"input_Input__kuwd8","Borderless":"input_Borderless__1zp6B","File":"input_File__1I26h"};